import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the user searches for integrations on the integrations settings page',
  name: 'integrations_searched',
  params: [
    {
      description: 'The search query entered by the user',
      name: 'search_query',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
